<cdk-accordion class="expansion-panel">
	<cdk-accordion-item
        #accordionItem="cdkAccordionItem"
		[expanded]="expanded()"
		role="button">

		<div class="flex-row align-items-center"
			 [ngClass]="{'p-16 pb-8': indented()}"
			 (click)="accordionItem.toggle()">
			<div class="flex-grow-1 cursor-pointer">
				<div class="panel-title-text">{{ primaryText() }}</div>
				@if (secondaryText()) {
					<div class="panel-description-text">{{ secondaryText() }}</div>
				}
			</div>

			<mat-slide-toggle [hideIcon]="true"
							  (change)="handleChange($event)"
							  [checked]="accordionItem.expanded"
							  (click)="$event.stopPropagation()">
			</mat-slide-toggle>
		</div>

		<section class="panel-content"
				 [@collapse]="accordionItem.expanded">
			<div>
				<ng-content></ng-content>
			</div>
		</section>
	</cdk-accordion-item>
</cdk-accordion>
